// import checkAccess from "./checkAccess";

// const users = JSON.parse(localStorage.getItem("jandle-admin"));

// let isAdmin = false;
// let hasDataManagement = false;

// let dataManageArray = [
//   "country",
//   "report_category",
//   "colors",
//   "language",
//   "security_question",
//   "reject_reason",
// ];

// if (users && typeof users === "object") {
//   const useArray = Object.values(users);
//   const adminUser = useArray?.find((user) => user?.role === "Admin");

//   if (adminUser) {
//     isAdmin = true;
//   }
// } else if (users?.role === "Admin") {
//   isAdmin = true;
// }

// dataManageArray.forEach((item) => {
//   if (checkAccess(`read_${item}`)) {
//     hasDataManagement = true;
//   }
// });

export const MENU_SIDEBAR = [
  { title: "Dashboard", path: "/dashboard", id: "skip" },
  {
    title: "Users",
    path: "/user",
    action: "read",
    id: "users",
  },
  // ...(hasDataManagement
  //   ? [
  {
    title: "Data Management",
    children: [
      {
        title: "Countries",
        path: "/data-management/country",
        action: "read",
        id: "country",
      },
      // {
      //   title: "Language",
      //   path: "/data-management/language",
      //   action: "read",
      //   id: "language",
      // },
      {
        title: "Delete Account Reasons",
        path: "/data-management/reject-reason",
        action: "read",
        id: "reject_reason",
      },
      {
        title: "Block Account Reasons",
        path: "/data-management/block-reason",
        action: "read",
        id: "block_reason",
      },
      {
        title: "Cancel Plan Reasons",
        path: "/data-management/cancelPlan-reason",
        action: "read",
        id: "cancelPlan-reason",
      },
      {
        title: "Tags",
        path: "/data-management/tags",
        action: "read",
        id: "tags",
      },
      {
        title: "Badge",
        path: "/data-management/badge",
        action: "read",
        id: "badge",
      },
      {
        title: "Message Templates",
        path: "/data-management/message-template",
        action: "read",
        id: "message_template",
      },
      {
        title: "Follow Up Templates",
        path: "/data-management/followUp-template",
        action: "read",
        id: "followup_template",
      },
      {
        title: "Event Listing",
        path: "/data-management/event-listing",
        action: "read",
        id: "event_listing",
      },
    
    ],
    action: "read",
    id: "skip",
  },
  //     ]
  //   : []),
  // ...(isAdmin
  //   ? [
  // {
  //   title: "Members & Roles",
  //   children: [
  //     {
  //       title: "Roles",
  //       path: "/access-management/roles",
  //       action: "read",
  //       id: "roles",
  //     },
  //     {
  //       title: "Permissions",
  //       path: "/access-management/permission",
  //       action: "read",
  //       id: "permission",
  //     },
  //     {
  //       title: "Team Members",
  //       path: "/access-management/team-members",
  //       action: "read",
  //       id: "team_member",
  //     },
  //   ],
  //   action: "read",
  //   id: "roles",
  // },
  //   ]
  // : []),
];
